export const SEX_LANG_PIPE_I18N = {
  sex: {
    male: $localize`:@@shared.sexLangPipe.sex.male:男性`,
    female: $localize`:@@shared.sexLangPipe.sex.female:女性`,
    other: $localize`:@@shared.sexLangPipe.sex.other:その他`,
  },
} as const;
